/* template */
<template><div id="makeorder-travel-service" class="service-business"><template v-if="(rightsInfo.length > 1)"><mulit-service @selectService="selectService" @openRightsDescDrawer="openRightsDescDrawer"/></template><template v-else><single-service @selectService="selectService" @openRightsDescDrawer="openRightsDescDrawer"/></template></div></template>

/* styles */
<style scoped lang="stylus" mpxStyleOptions='{"mid":"m92ff474e"}'>
  .service-business
    margin-top 10px
</style>

/* json */
/* script */
<script>
  import processOption, { getComponent, getWxsMixin } from "@mpxjs/webpack-plugin/lib/runtime/optionProcessor"
  const wxsModules = {}
  global.currentModuleId = "m92ff474e"
  global.currentSrcMode = "wx"
  /** script content **/
  require("./index.mpx.js?isComponent&outputPath=components%2Findex92ff474e%2Findex!=!@mpxjs/webpack-plugin/lib/selector?mode=web&env=!./index.mpx?ctorType=component&index=0&isComponent&mpx&outputPath=components%2Findex92ff474e%2Findex&type=script")
  const currentOption = global.__mpxOptionsMap["m92ff474e"]
  export default processOption(
    currentOption,
    "component",
    "",
    "components/index92ff474e/index",
    {},
    // @ts-ignore
    {},
    // @ts-ignore
    {'mulit-service':getComponent(require("./mulit-service.mpx?isComponent&outputPath=components%2Fmulit-service23d087de%2Findex")),'single-service':getComponent(require("./single-service.mpx?isComponent&outputPath=components%2Fsingle-service2b54ca37%2Findex"))},
    undefined,
    {},
    undefined,
    getWxsMixin(wxsModules)
  )
</script>
